import type { PasswordState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../AppState';

const selectPasswordDomain = (state: AppState): PasswordState => state.password;

export const selectChangePasswordByRecoveryTokenWebData = compose(
  (domainState: PasswordState) =>
    domainState.changePasswordByRecoveryTokenWebData,
  selectPasswordDomain
);

export const selectForgetPasswordWebData = compose(
  (domainState: PasswordState) => domainState.forgetPasswordWebData,
  selectPasswordDomain
);

export const selectValidateTokenWebData = compose(
  (domainState: PasswordState) => domainState.validateTokenWebData,
  selectPasswordDomain
);
